import { useSyncExternalStore } from 'react';
import { quest, type QuestState } from '../utils/quest';

/** Live quest state (re-renders on every quest event) */
export function useQuest(): QuestState {
  return useSyncExternalStore(quest.subscribe, quest.getState, quest.getState);
}
